// extracted by mini-css-extract-plugin
export default {"app":"Layout_app__tbAZi","popupOpened":"Layout_popupOpened__73Abc"};